import { MutableRefObject, useRef, useState } from 'react';

export default function useAsyncRef(
  value: number
): [MutableRefObject<number>, (newState: number) => void] {
  const ref = useRef<number>(value);
  const [, forceRender] = useState(false);

  function updateState(newState: number) {
    ref.current = newState;
    forceRender(s => !s);
  }

  return [ref, updateState];
}
